<template>
  <v-app>
      <v-container class="mt-5 ">
          <v-row class="">
              <v-col lg="12" class="text-right">
                  <v-btn>
                      <v-icon>mdi-currency-usd</v-icon>
                      Nuevo anticipo
                  </v-btn>
              </v-col>
          </v-row>
          <v-row class="bold text-center justify-content-center mt-5">
              <v-col lg="3">Empleado</v-col>
              <v-col lg="3">Monto Asignado</v-col>
              <v-col lg="3">Fecha</v-col>
              <v-col lg="3">Autorizo</v-col>
          </v-row>
          <v-row v-for="user in users" :key="user.id" class="justify-content-center text-center">
              <v-col lg="3">{{user.name}}</v-col>
              <v-col lg="3">{{user.anticipo| currency}}</v-col>
              <v-col lg="3">{{user.fecha}}</v-col>
              <v-col lg="3">{{user.autorizo}}</v-col>
          </v-row>
      </v-container>
  </v-app>
</template>

<script>
import axios from 'axios'
export default {
    data(){
        return {
            users: []
        }
    },
    methods: {
        getData: async function(){
            let {data} =await axios.get('https://127.0.0.1:3000/anticipo/')
            this.users=data
        }
    },
    mounted(){
        this.getData()
    }
}
</script>

<style>
    .bold {
        font-weight: bolder
    }
</style>